
<div>
    <f-dialog
        v-model       = "edit"
        :width        = "550"
        :show-header  = "false"
        :hide-actions = "true"
        content-class = "dialog-border"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div style="position: relative" class="pl-2 mr-2">
                <div class="close-button">
                    <c-toolbar-button
                        size     = "28"
                        color    = "red"
                        icon     = "mdi-close"
                        :tooltip = "$t('common.cancel')"
                        @click   = "onCancel"
                    />
                </div>

                <div class="mb-5">
                    <div class="doc-header">
                        Aktuelle Version
                    </div>
                    <div class="date-header primary--text v-flex">
                        Dokumentenart / Name
                        <v-spacer />

                        <div class="header-title primary--text">
                            Erstellung am / von
                        </div>
                    </div>
                    <v-card
                        flat
                        class  = "lm-border doc-entry mb-1 mr-1"
                        @click = "onShowDocument"
                    >
                        <div style="display: block" class="pl-2 doc-col">
                            <div class="doc-info v-flex">
                                <!-- unit chip -->
                                <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
                                    {{ document.unitName }}
                                </div>
                                <!-- unit chip -->

                                <!-- document type -->
                                <div>
                                    {{ document.type ? document.type.name : '---' }}
                                </div>
                                <!-- document type -->

                                <v-spacer />
                            </div>

                            <div class="doc-subinfo doc-filename">
                                {{ document.name }}
                            </div>
                        </div>

                        <v-spacer  />

                        <div style="display: block; margin-right: 24px" >
                            <div class="doc-date pr-2">
                                {{ timeAsString(document.createdDate) }}
                            </div>
                            <div class="doc-subinfo">
                                {{ document.createdBy }}
                            </div>
                        </div>
                    </v-card>

                    <div class="doc-header" v-if="versions">
                        Frühere Versionen
                    </div>
                    <div class="date-header primary--text v-flex" v-if="versions">
                        Name / Version
                        <v-spacer />

                        <div class="header-title primary--text">
                            Erstellung am / von
                        </div>
                    </div>

                    <div class="scroll-area" v-if="versions">
                        <a
                            v-for  = "(version, index) in versions"
                            :key   = "index"
                        >
                            <v-hover
                                v-slot = "{ hover }"
                            >
                                <p-dms-version
                                    :document     = "document"
                                    :version      = "version"
                                    :step-data-id = "stepDataId"
                                    :hover        = "hover"
                                    @removed      = "onRemoved"
                                />
                            </v-hover>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </f-dialog>
</div>
